export const ru = {
    'help-title': 'Помощь'
};
